import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDeviceDetectionJobsByOrganizationIdsQueryVariables = Types.Exact<{
  organization_ids?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
}>;


export type GetDeviceDetectionJobsByOrganizationIdsQuery = { __typename?: 'query_root', device_detection_jobs: Array<{ __typename?: 'device_detection_jobs', id: any, workspace_id?: any | null, status: string, input_files?: any | null, ai_response?: any | null, detected_devices?: any | null, detected_installed_products?: any | null, products_grouped_by_type?: any | null, created_at?: any | null, updated_at: any, property_id: any, organization_id?: any | null, created_by_user_id?: string | null, property: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null }, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, author?: { __typename?: 'users', first_name: string, last_name: string, email: string } | null }> };


export const GetDeviceDetectionJobsByOrganizationIdsDocument = gql`
    query getDeviceDetectionJobsByOrganizationIds($organization_ids: [uuid!]) {
  device_detection_jobs(
    where: {organization_id: {_in: $organization_ids}}
    order_by: {created_at: asc}
  ) {
    id
    workspace_id
    status
    input_files
    ai_response
    detected_devices
    detected_installed_products
    products_grouped_by_type
    created_at
    updated_at
    property_id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      photo_link
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
    }
    created_by_user_id
    author {
      first_name
      last_name
      email
    }
  }
}
    `;

/**
 * __useGetDeviceDetectionJobsByOrganizationIdsQuery__
 *
 * To run a query within a React component, call `useGetDeviceDetectionJobsByOrganizationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceDetectionJobsByOrganizationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceDetectionJobsByOrganizationIdsQuery({
 *   variables: {
 *      organization_ids: // value for 'organization_ids'
 *   },
 * });
 */
export function useGetDeviceDetectionJobsByOrganizationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetDeviceDetectionJobsByOrganizationIdsQuery, GetDeviceDetectionJobsByOrganizationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceDetectionJobsByOrganizationIdsQuery, GetDeviceDetectionJobsByOrganizationIdsQueryVariables>(GetDeviceDetectionJobsByOrganizationIdsDocument, options);
      }
export function useGetDeviceDetectionJobsByOrganizationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceDetectionJobsByOrganizationIdsQuery, GetDeviceDetectionJobsByOrganizationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceDetectionJobsByOrganizationIdsQuery, GetDeviceDetectionJobsByOrganizationIdsQueryVariables>(GetDeviceDetectionJobsByOrganizationIdsDocument, options);
        }
export function useGetDeviceDetectionJobsByOrganizationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceDetectionJobsByOrganizationIdsQuery, GetDeviceDetectionJobsByOrganizationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceDetectionJobsByOrganizationIdsQuery, GetDeviceDetectionJobsByOrganizationIdsQueryVariables>(GetDeviceDetectionJobsByOrganizationIdsDocument, options);
        }
export type GetDeviceDetectionJobsByOrganizationIdsQueryHookResult = ReturnType<typeof useGetDeviceDetectionJobsByOrganizationIdsQuery>;
export type GetDeviceDetectionJobsByOrganizationIdsLazyQueryHookResult = ReturnType<typeof useGetDeviceDetectionJobsByOrganizationIdsLazyQuery>;
export type GetDeviceDetectionJobsByOrganizationIdsSuspenseQueryHookResult = ReturnType<typeof useGetDeviceDetectionJobsByOrganizationIdsSuspenseQuery>;
export type GetDeviceDetectionJobsByOrganizationIdsQueryResult = Apollo.QueryResult<GetDeviceDetectionJobsByOrganizationIdsQuery, GetDeviceDetectionJobsByOrganizationIdsQueryVariables>;